/**
 * ドライバースケジュール
 * 並び替え
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const driver_schedule_schedule_sort_priority = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * スケジュール 並び替え
     * @param commit
     * @param driver_schedule_id
     * @param params
     * @returns {Promise<unknown>}
     */
    update ({ commit }, { driver_schedule_id, params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/${driver_schedule_id}/schedule_sort_priorities`, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}
export default driver_schedule_schedule_sort_priority
